import React, { useCallback } from 'react';
import SearchInput from '@/creditflowresearch/ui/common/components/molecules/SearchInput';
import debounce from 'lodash/debounce';
import { useResearchContext } from '@/creditflowresearch/application/Research/ResearchContext';
import URL from '@/creditflowresearch/Router/urlConstants';
import { useRouter } from 'next/router';
import Router, { removeQueryParams } from '@framework/router';
import { addQueryParams } from '@framework/router/nextRouter';

const SearchContainer = () => {
  const {
    query,
    pathname,
  } = useRouter();
  const {
    getResearchForAllGroups,
    searchFieldValue,
    setSearchFieldValue,
  } = useResearchContext();

  const debouncedSearchRequest = useCallback(debounce((search) => {
    getResearchForAllGroups({
      page: 1,
      search,
    });
    if (pathname.includes(URL.NRSRO_RESEARCH)) {
      Router.push({
        query: search
          ? addQueryParams(query, { q: search })
          : removeQueryParams(query, ['q']),
      }, undefined, { shallow: true });
    }
  }, 200), [getResearchForAllGroups, pathname, query]);

  const onChange = ({ target }) => {
    setSearchFieldValue(target.value);

    debouncedSearchRequest(target.value);
  };

  return (
    <SearchInput
      onChange={ onChange }
      placeholder="Filter by Name"
      dataTest="researchSearchInput"
      name="researchSearchInput"
      // @ts-ignore
      value={ searchFieldValue }
    />
  );
};

export default SearchContainer;
